import { createSelector } from 'reselect';
import { getUsersState } from 'src/modules/users/selectors/getUsersState';

export const getUsersSortingTarget = createSelector([
  getUsersState,
], (state) => state.sortingTarget);
